import { Typography, useTheme } from '@mui/material';

import type { HeaderProps } from './Header.types';

export function Header({ children, ...props }: HeaderProps) {
  const { tokens } = useTheme();

  return (
    <Typography color={tokens.cardValueSubHeader} variant="body3" {...props}>
      {children}
    </Typography>
  );
}
